import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {Button, TextField, Typography} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import * as Yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {config} from "../../../constant";

export default function DialogEditArchiveCategory({open, onClose, archiveCategoryId}) {
    const [fetched, setFetched] = useState(false);
    const navigate = useNavigate();

    const validationSchema = Yup.object().shape({
        name: Yup.string().required("Nom est obligatoire")
    });

    const {register, reset, control, handleSubmit, formState: {errors}} = useForm({
        resolver: yupResolver(validationSchema)
    });

    const onSubmit = (data) => {
        const requestOptions = {
            method: archiveCategoryId === null ? 'POST' : 'PUT',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(data)
        };
        fetch(`${config.BASE_URL}/archive-categories`, requestOptions)
            .then(response => {
                onClose(true);
                if (!response.ok) {
                    throw new Error(`${response.status} ${response.statusText}`)
                }
            })
            .catch((error) => {
                const message = 'Erreur dans la création ou mise à jour d\'une catégorie archive';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    };

    useEffect(() => {
        if (archiveCategoryId) {
            fetch(`${config.BASE_URL}/archive-categories/${archiveCategoryId}`)
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`${response.status} ${response.statusText}`)
                    }
                    return response.json();
                }).then(data => {
                    reset(data);
                    setFetched(true);
                })
                .catch((error) => {
                    const message = 'Erreur dans la récupération de la catégorie archive';
                    console.error(message, error);
                    navigate("/error", {state: {message: message}});
                });
        }
    }, []);

    return (
        <Dialog open={open} onClose={() => onClose(false)} maxWidth={'lg'}>
            <DialogTitle>Catégorie archive</DialogTitle>
            <DialogContent>
                {(!archiveCategoryId || fetched) && (
                    <form id="archiveCategoryForm" onSubmit={handleSubmit(onSubmit)}>
                        <TextField
                            margin="dense"
                            id="name"
                            name="name"
                            label="Nom"
                            fullWidth
                            variant="standard"
                            {...register("name")}
                            error={!!errors.name}
                        />
                        <Typography variant="inherit" color="textSecondary">{errors.name?.message}</Typography>
                    </form>
                )}
            </DialogContent>
            <DialogActions>
                <Button type="submit" form="archiveCategoryForm">OK</Button>
                <Button onClick={() => onClose(false)}>Annuler</Button>
            </DialogActions>
        </Dialog>
    );
}
